import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  public get(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  public set(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public removeBy(key: string): void {
    sessionStorage.removeItem(key);
  }

  public checkKey(key: string): boolean {
    return this.get(key) ? true : false;
  }

  public clear(): void {
    sessionStorage.clear();
  }
}
